import React from 'react'
import PropTypes from 'prop-types'
import Joyride from 'react-joyride'

/* Onbaording (via react-joyride) experience for TopicPlan page */
export default class AudienceLiftOnBoarding extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    includeTlm: PropTypes.bool.isRequired,
    run: PropTypes.bool.isRequired,
    selectedNetwork: PropTypes.string
  }

  static defaultProps = {
    includeTlm: true
  }

  render () {
    // This fills up the logs quite a bit...so let's disable it by default.
    const debug = false
    return (
      <Joyride
        steps={this._steps()}
        run={this.props.run}
        debug={debug}
        continuous
        controlled
        showProgress
        showSkipButton
      />
    )
  }

  _steps () {
    const common = {
      placement: 'auto',
      placementBeacon: 'auto',
      disableBeacon: false,
      styles: {
        options: {
          zIndex: 10000
        }
      },
      locale: { skip: 'Skip tour' }
    }
    let steps = [
      {
        ...common,
        content: (<p>Welcome to the Diesel Labs Audience Lift for {this.props.selectedNetwork}!<br /><br />The Audience Lift view shows a comparison of premiere performance in driving new audience engagement for every original title for a platform or network.<br /><br />Premiere performance is defined as audience engagement from launch through day 7 of each original title.<br/><br/>Let's Go!</p>),
        placement: 'center',
        disableBeacon: true,
        target: 'body'
      }
    ]

    return steps
  }
}
